import { Deserializable, Dictionary } from '@app/core/models';

export enum FieldType {
  CHECKBOX = 'checkbox',
  SELECT = 'select',
}

export enum AggFunction {
  SUM = 'SUM',
  COUNT = 'COUNT',
}

export class FieldInfo implements Deserializable {
  /** Отображаемое название */
  viewValue?: string;

  /** Подсказка к отображаемому названию */
  help?: string;

  /** Возможные значения (для селектов) */
  values?: any[];

  /** Какое поле использовать для фильтра. При null поле не используется для фильтрации */
  type?: FieldType;

  /** Можно ли группировать по полю */
  group?: boolean;
  /** Является ли группировкой по умолчанию */
  groupDefault?: boolean;

  /** Возможные функции для аггрегации значений. При null поле нельзя использовать как значение  */
  aggFunction?: AggFunction[];

  /** Название поля */
  field?: string;

  constructor(object: unknown) {
    this.deserialize(object);
  }

  deserialize?(object: any): this {
    if (!object) {
      return this;
    }

    this.viewValue = object.viewValue;
    this.help = object.help;
    this.values = object.values;
    this.type = object.type as FieldType;
    this.group = !!object.group;
    this.groupDefault = !!object.groupDefault;

    if (Array.isArray(object.aggFunction)) {
      this.aggFunction = object?.aggFunction;
    }

    this.field = object.field;
    return this;
  }

  static deserializeDict(fields: Dictionary<string, any>): Dictionary<string, FieldInfo> {
    const result: Dictionary<string, FieldInfo> = { };

    Object.keys(fields).forEach(key => {
      result[key] = new FieldInfo({ ...fields[key], field: key });
    });

    return result;
  }
}
